import { COUNTRY_PRICING, EU_COUNTRIES } from '../config/pricing'
import * as countryService from './countryService'

class CountryManager {
  // TODO: This needs to move out of here
  getPricingCountry(inputCountry) {
    return getPricingCountry(inputCountry || this.getCountry())
  }

  getCountry() {
    return countryService.getCountry()
  }

  getState() {
    return countryService.getState()
  }

  isClientFromEU() {
    return EU_COUNTRIES.includes(this.getCountry().toUpperCase())
  }

  isClientFromGB() {
    return this.getCountry().toUpperCase() === 'GB'
  }
}

export const countryManager = new CountryManager()

export function getPricingCountry(inputCountry) {
  const country = inputCountry
  return country && country.toLowerCase() in COUNTRY_PRICING ? country : 'US'
}
